<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 48 48"
    aria-hidden="true"
  >
    <g>
      <path
        d="M24.258,6.047A18.211,18.211,0,1,1,6.047,24.258,18.211,18.211,0,0,1,24.258,6.047m0-4.047A22.156,22.156,0,1,0,40.026,8.489,22.258,22.258,0,0,0,24.258,2Z"
        transform="translate(-0.258 -0.258)"
        fill="currentColor"
      />
      <path
        d="M26.938,24.106,32.6,18.541a2.125,2.125,0,0,0,.2-2.732,1.922,1.922,0,0,0-3.035-.2l-5.666,5.666L18.44,15.608a1.922,1.922,0,0,0-3.035.2,2.125,2.125,0,0,0,.2,2.732l5.666,5.564L15.607,29.67a2.125,2.125,0,0,0-.2,2.732,1.922,1.922,0,0,0,3.035.2l5.666-5.666L29.771,32.6a1.922,1.922,0,0,0,3.035-.2,2.125,2.125,0,0,0-.2-2.732Z"
        transform="translate(-0.105 -0.105)"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
